import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { Link } from 'react-router-dom';
import data from '../../utils/dbSchema';
import { Box } from '../UI';
import Search from './Search';

export default function Sidebar({ height, handleFilterChange }) {
	return (
		<Box height={height} minWidth="318px" style={{ overflowY: 'scroll' }}>
			<ExpansionPanel>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography>
						<strong>Browse Properties</strong>
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ padding: 0 }}>
					<List component="nav" aria-label="main mailbox folders" style={{ width: '100%' }}>
						{data.properties.map(property => {
							if (property.sell.digitalId > 99) {
								return (
									<ListItem
										key={property.id}
										button
										component={Link}
										to={`/market-search/${property.id}`}
									>
										<ListItemText primary={property.id} secondary={property.sell.address} />
									</ListItem>
								);
							} else return null;
						})}
					</List>
				</ExpansionPanelDetails>
			</ExpansionPanel>
			<ExpansionPanel defaultExpanded={true}>
				<ExpansionPanelSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography>
						<strong>Search Profile</strong>
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails style={{ padding: 0 }}>
					<Search handleFilterChange={handleFilterChange} />
				</ExpansionPanelDetails>
			</ExpansionPanel>
		</Box>
	);
}
